export default "__VITE_ASSET__3bca32a8__"